import React from 'react';
import PropTypes from 'prop-types';
import styles from './Resources.module.css';
import Resource from './Resource';

const linkShape = PropTypes.shape({
  displayText: PropTypes.string.isRequired,
  target: PropTypes.string.isRequired,
}).isRequired;
const resourceShape = PropTypes.shape({
  link: linkShape.isRequired,
  description: PropTypes.string.isRequired,
}).isRequired;
const resourceGroupShape = PropTypes.shape({
  title: PropTypes.string.isRequired,
  resources: PropTypes.arrayOf(resourceShape).isRequired,
}).isRequired;

const propTypes = {
  resources: PropTypes.arrayOf(resourceGroupShape).isRequired,
};

function Resources({ resources }) {
  const renderResource = (resourceDetail, key) => {
    return <Resource resourceDetail={resourceDetail} key={key} />;
  };

  const renderGrouping = (resourceGrouping, key) => {
    const groupResources = resourceGrouping.resources.map((resource, index) => renderResource(resource, index));

    return (
      <section className={styles['group']} key={key} tabIndex={0}>
        <p className={styles['group-title']}>{resourceGrouping.title}</p>
        {groupResources}
      </section>
    );
  };

  const renderedResources = resources.map((resourceGrouping, index) => renderGrouping(resourceGrouping, index));

  return <article className={styles['container']}>{renderedResources}</article>;
}

Resources.propTypes = propTypes;

export default Resources;
